import React, { useMemo } from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Box,
  Spinner,
  Divider,
  Heading,
  Grid,
  GridItem,
  Badge,
  Flex,
  Progress,
} from '@chakra-ui/react'
import { useAcompanhamentoApasService } from '../hooks/useAcompanhamentoApasService'

export const ModalSumarioAcompanhamentoApas = ({ isOpen, onClose }) => {
  const { clientes, isLoading, error } = useAcompanhamentoApasService()

  const estatisticas = useMemo(() => {
    if (!clientes || !clientes.length) return null

    const totalClientes = clientes.length

    const porVendedor = {}
    clientes.forEach((cliente) => {
      const vendedor = cliente.nome_vendedor || 'Não informado'
      if (!porVendedor[vendedor]) {
        porVendedor[vendedor] = {
          quantidade: 0,
        }
      }
      porVendedor[vendedor].quantidade += 1
    })

    const vendedoresArray = Object.entries(porVendedor).map(([vendedor, dados]) => ({
      vendedor,
      ...dados,
      percentualQuantidade: (dados.quantidade / totalClientes) * 100,
    }))

    vendedoresArray.sort((a, b) => b.quantidade - a.quantidade)

    return {
      totalClientes,
      porVendedor: vendedoresArray,
    }
  }, [clientes])

  if (isLoading) {
    return (
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Sumário de Acompanhamento APAS</ModalHeader>
          <ModalCloseButton />
          <ModalBody textAlign="center" py={10}>
            <Spinner size="xl" color="blue.500" />
            <Text mt={4}>Carregando sumário de acompanhamento...</Text>
          </ModalBody>
        </ModalContent>
      </Modal>
    )
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="3xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Sumário de Acompanhamento APAS</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {error ? (
            <Box textAlign="center" py={4}>
              <Text color="red.500">Erro ao carregar o sumário. Por favor, tente novamente.</Text>
            </Box>
          ) : estatisticas ? (
            <>
              <Grid templateColumns="repeat(2, 1fr)" gap={4} mb={6}>
                <GridItem colSpan={2}>
                  <Heading size="sm" mb={2}>
                    Visão Geral de Clientes
                  </Heading>
                </GridItem>

                <Box p={3} borderWidth="1px" borderRadius="lg" bg="blue.50">
                  <Text fontWeight="bold" mb={2}>
                    Total de Clientes no Período
                  </Text>
                  <Flex>
                    <Badge colorScheme="blue" fontSize="lg" p={2}>
                      {estatisticas.totalClientes}
                    </Badge>
                  </Flex>
                </Box>
              </Grid>

              <Divider my={4} />

              <Heading size="sm" mb={2}>
                Clientes por Empresa
              </Heading>
              <Box mb={4}>
                <Table variant="simple" size="sm">
                  <Thead bg="#378BBF">
                    <Tr>
                      <Th color="white" borderBottom="none" borderRight="none">
                        Vendedor
                      </Th>
                      <Th color="white" borderBottom="none" borderRight="none" isNumeric>
                        Quantidade
                      </Th>
                      <Th color="white" borderBottom="none" isNumeric>
                        % Total
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {estatisticas.porVendedor.map((item, index) => (
                      <Tr key={item.empresa} bg={index % 2 === 1 ? 'gray.50' : 'white'}>
                        <Td borderBottom="none">{item.vendedor}</Td>
                        <Td isNumeric borderBottom="none">
                          {item.quantidade}
                        </Td>
                        <Td borderBottom="none">
                          <Flex justify="flex-end" align="center" gap={2}>
                            <Progress value={item.percentualQuantidade} size="xs" colorScheme="blue" width="60px" borderRadius="md" />
                            <Badge colorScheme="blue">{item.percentualQuantidade.toFixed(1)}%</Badge>
                          </Flex>
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </Box>
            </>
          ) : (
            <Box textAlign="center" py={4}>
              <Text>Nenhum cliente disponível para mostrar.</Text>
            </Box>
          )}
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            Fechar
          </Button>
          {estatisticas && (
            <Text fontSize="sm" color="gray.500">
              Total: {estatisticas.totalClientes} cliente(s) cadastrados
            </Text>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
